import { parseDocumentFromString, serializeDocument } from 'anodum';
import generateBlockId from '../../blocks/helpers/generate-block-id';
import blocksConstants from '../../blocks/constants/common';
import linkEditingConstants from '../../link-editing/constants';

const { common, linkTypes } = linkEditingConstants;

const { BLOCK_ID_PREFIX } = blocksConstants;

const syncRelatedAnchorLinks = (pageHTML, oldBlockId, newBlockId, oldPageId, newPageId) => {
  const relatedAnchorLinks = pageHTML.querySelectorAll(
    `a[${common.LINK_CONFIG_ATTRIBUTE}='{"linkType":"${linkTypes.ANCHOR}","reference":"${oldBlockId}","pageId":"${oldPageId}"}']`
  );

  if (relatedAnchorLinks.length) {
    relatedAnchorLinks.forEach((link) => {
      link.setAttribute(
        common.LINK_CONFIG_ATTRIBUTE,
        `{"linkType":"${linkTypes.ANCHOR}","reference":"${newBlockId}","pageId":"${newPageId}"}`
      );
    });
  }
};

const getBlockIdBase = (id) => {
  const rawBase = id.replace(`${BLOCK_ID_PREFIX}-`, '');
  return rawBase.substring(0, rawBase.lastIndexOf('-'));
};

const replaceBlocksIdInHtml = (html, targetPageId, newPageId) => {
  const pageHTML = parseDocumentFromString(html);
  const pageBlocks = pageHTML.querySelectorAll(`[id^="${BLOCK_ID_PREFIX}"`);

  pageBlocks.forEach((block) => {
    const blockIdBase = getBlockIdBase(block.id);
    const newBlockId = generateBlockId(blockIdBase);

    // we should also handle anchor links which might lead to that block id
    syncRelatedAnchorLinks(pageHTML, block.id, newBlockId, targetPageId, newPageId);

    // eslint-disable-next-line
    block.id = newBlockId;
  });

  return serializeDocument(pageHTML);
};

export default replaceBlocksIdInHtml;
